import { defineMessages, type IntlShape } from 'react-intl';

const eligibilityI18n = defineMessages({
	releaseNoteKeywordForModalTrigger: {
		id: 'automation-discovery.rovo.release-note.trigger.keyword',
		defaultMessage: 'release note',
		description:
			'We look for this phrase in a Confluence page title in order to determine if an automation modal should be shown',
	},
});

export const isEligibleForReleaseNotesDiscovery = (
	pageTitle: string,
	intl: Pick<IntlShape, 'formatMessage'>,
): boolean => {
	// show the dialog if title contains "release note"
	return pageTitle
		.toLowerCase()
		.includes(intl.formatMessage(eligibilityI18n.releaseNoteKeywordForModalTrigger));
};
